import PropTypes from 'prop-types';
import React, {useState} from 'react';
import { Paper, TablePagination} from '@material-ui/core';
import { withTranslation } from 'react-i18next';
import MTable, { MTableBodyRow } from 'material-table';
import { CsvBuilder } from "filefy";
import SaveAlt from "@material-ui/icons/SaveAlt";
import ShuffleIcon from '@material-ui/icons/Shuffle';
import Sync from '@material-ui/icons/Sync';

import { corpusConcordsShape } from './shapes';
import { prepDangerouslySetInnerHTMLString,formatMeta } from './utils';
import { stripBracket } from '../../../utils';


import './UnfoldedView.css';


function UnfoldedView(props) {
  const { concords, getConcordDetail, permalink, t } = props;
  const [shuffled,setShuffled]=useState(false);
  
  const shuffleArray = (array) => {
    let curId = array.length;
    // There remain elements to shuffle
    while (0 !== curId) {
      // Pick a remaining element
      let randId = Math.floor(Math.random() * curId);
      curId -= 1;
      // Swap it with the current element.
      let tmp = array[curId];
      array[curId] = array[randId];
      array[randId] = tmp;
    }
    return array;
  }

  const data=shuffled ? shuffleArray(concords): concords;
  if (! data || ! data[0]) { return <></>};

  var biconcordance=false;
  var alignedVersions=false;
  var correspSentsLength=0;

  for (var i in data) {
    if (data[i].alignedSent) {
      biconcordance=true;
    }
    if (data[i].correspSents) {
      alignedVersions=true;
      var l=Object.keys(data[i].correspSents).length ;

      if (l > correspSentsLength) {
        correspSentsLength=l;
      }
    }
  }
  var COLUMNS;

  if (biconcordance) {
    COLUMNS=[
      { title: t('source'), 
        field: 'source', 
        render: rowData => <div className='kwicRow' dangerouslySetInnerHTML={prepDangerouslySetInnerHTMLString(rowData.left+rowData.node+rowData.right)} /> ,
        customFilterAndSearch: (term, rowData) => (rowData.left+rowData.node+rowData.right).match(term),
        cellStyle: {
          //width: '50%',
          textAlign:'left'
        },
        headerStyle:{
          textAlign:'center'
        }
      },
      
      { title: t('target'), 
        field: 'node', 
        render: rowData => <div className='kwicRow' dangerouslySetInnerHTML={prepDangerouslySetInnerHTMLString(rowData.alignedSent)} /> ,
        customFilterAndSearch: (term, rowData) => rowData.alignedSent?(rowData.alignedSent).match(term):false,
        cellStyle:{
          textAlign:'left'
        }, 
        headerStyle:{
          textAlign:'center'
        }
      }    
    ];
  } else if (alignedVersions) {
    COLUMNS=[
      { title: t('unfolded'), 
        field: 'source', 
        render: rowData => <div className='kwicRow' dangerouslySetInnerHTML={prepDangerouslySetInnerHTMLString(rowData.left+rowData.node+rowData.right)} /> ,
        cellStyle: {
          //width: '100%',
          textAlign:'left'
        },
        headerStyle:{
          textAlign:'center'
        }
      }
    ];
    // as we want to do a closure with the value of j, it is necessary to use 'let'
    for (let j=0;j<correspSentsLength;j++) {
      COLUMNS.push(
        { title:  t('otherVersion'),  
          field: 'version'+j.toString(), 
          render: rowData => rowData.correspSents?<div className='kwicRow' dangerouslySetInnerHTML={prepDangerouslySetInnerHTMLString(rowData.correspSents[Object.keys(rowData.correspSents)[j]])} /> : <div className='kwicRow' /> ,
          cellStyle:{
            textAlign:'left'
          }, 
          headerStyle:{
            textAlign:'center'
          }
        }    
      );
    }

  } else {
    COLUMNS=[
      { title: t('unfolded'), 
        field: 'source', 
        render: rowData => <div className='kwicRow' dangerouslySetInnerHTML={prepDangerouslySetInnerHTMLString(rowData.left+rowData.node+rowData.right)} /> ,
        cellStyle: {
          width: '100%',
          textAlign:'left'
        },
        headerStyle:{
          textAlign:'center'
        }
      }
    ];

  }


  // console.log("init id="+selectedRowId);
  return (
    <MTable
      title={t('conc')}
      columns={ COLUMNS }
      data={data}
      localization={{
        toolbar: {
          exportCSVName: "Export as TXT",
          exportPDFName: "Export as PDF"
        }
      }}

      options={{
        selection:true,
        filtering:true,
        search: true,
        sorting: true,
        exportButton: true,
        exportFileName: 'concordances',
        //exportAlldata: true,
        rowStyle: (rowData) => ({
          height:'50px'
        }),
        exportCsv: (columns, data) => {
          const fileName = "Concordance_Table";
          const builder = new CsvBuilder(
              fileName + ".txt"
          );
          console.log(props.docMeta,props.metadataFormat);

          builder
              .setColumns(
                   ["sentId # sent # meta"]
              )
              .setDelimeter(props.csvDelimiter)
              .addRows(
                data.map((rowData) =>
                    [
                      rowData.sentId+"\t"+stripBracket(rowData.left+" "+rowData.node+" "+rowData.right)+"\t"+ formatMeta(props.docMeta[rowData.docId],props.metadataFormat)+"\t"+(rowData.alignedSent?rowData.alignedSent:"")
                    ]
                  )
              )
              .exportFile();
        },
      }}
      components={{
        Pagination: paginationProps => (
          <TablePagination
            {...paginationProps}
            rowsPerPageOptions={[5, 10, 25, 50, 100, 200, data.length]}
          />
        ),
        Container: containerProps => (
          <Paper
            {...containerProps}
            elevation={1}
          />
        ),
        Row: rowProps => (
          <MTableBodyRow
            {...rowProps}
            onRowClick = {(e,rowData) => getConcordDetail(rowData,"")}
            onDoubleClick = { () => { window.open(permalink,'_blank') }}
          />
        )
      }}
      // This custom export button id used for selected rows
      actions={[
        {
          icon: ShuffleIcon,
          isFreeAction: true, // pour avoir un affichage dans l'entête
          tooltip: "Shuffle the rows randomly!",
          onClick: () => {
            setShuffled(! shuffled);
          },
        },
        {
          icon: Sync,
          tooltip: "Run query only on the selected results!",
          onClick: (e,data) => {
            const selectedSents=data.map((rowData)=>rowData.subCorpus+"/"+props.docMeta[rowData.docId].collection+"/"+rowData.sentId);
            console.log("selectedSents",selectedSents)
            props.performSearch({selectedSents});
    
          }
        },
        {
            icon: SaveAlt,
            tooltip: "Export the selected rows!",
            onClick: (e,data) => {
                const fileName = "Concordance_Table";
                const builder = new CsvBuilder(
                    fileName + ".csv"
                );
                builder
                    .setColumns(
                        ["docId","left","node","right"]
                    )
                    .setDelimeter(props.csvDelimiter)
                    .addRows(
                      data.map((rowData) =>
                          [
                            rowData.docId,
                            rowData.left,
                            rowData.node,
                            rowData.right,
                            rowData.alignedSent?rowData.alignedSent:""
                          ]
                        )
                    )
                    .exportFile();
            },
        },
    ]}
    />
  );

}
  UnfoldedView.propTypes = {
  concords: corpusConcordsShape,
  permalink: PropTypes.string,
  getConcordDetail: PropTypes.func,
  selectedRowId: PropTypes.number,
  performSearch: PropTypes.func,
  docMeta: PropTypes.object,
  csvDelimiter: PropTypes.string, 
  metadataFormat: PropTypes.string  
};

export default withTranslation()(UnfoldedView);